import LookVirtualizedListLoadingItem
  from "../../../../../../../look/lookNavigation/lookMain/lookCategory/lookVirtualizedListLoadingItem";
import {Grid} from "react-virtualized";
import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {
  getGridColumnDimensions,
  useGridDimensions
} from "../../../commonTools/featuresGrid/gridDimensions";

export const SqftOptionsLoading = (props) => {
  const {isMobile, lookViewType, windowHeight} = props;

  const {gridWidth, gridHeight} = useGridDimensions(windowHeight, isMobile);
  const {columnCount, rowHeight} = getGridColumnDimensions(lookViewType);
  const columnWidth = Math.floor(gridWidth / columnCount) - 8 / columnCount;
  const rowCount = Math.ceil(gridHeight / rowHeight);

  const listSettings = {
    width: gridWidth,
    columnCount,
    columnWidth,
    rowCount,
    height: gridHeight,
    rowHeight: rowHeight,
    overscanRowCount: 3,
    showScrollingPlaceholder: false,
    useDynamicRowHeight: false,
  }

  const cellRenderer = ({columnIndex, key, rowIndex, style}) => {
    void columnIndex;
    void rowIndex;

    return <LookVirtualizedListLoadingItem style={style} key={key} viewType={lookViewType}/>
  }

  const noRowsRenderer = () => <div className={"ass-list"}>No Features found</div>;

  return (
    <Grid
      // ref="List"
      width={listSettings.width}
      height={listSettings.height}
      //onScroll={onScrollHandler}
      overscanRowCount={listSettings.overscanRowCount}
      rowCount={listSettings.rowCount}
      columnCount={listSettings.columnCount}
      columnWidth={listSettings.columnWidth}
      rowHeight={listSettings.rowHeight}
      cellRenderer={cellRenderer}
      noRowsRenderer={noRowsRenderer}
    />
  )
}

SqftOptionsLoading.propTypes = {
  // maxClickCountReached: PropTypes.func,
  // renderList: PropTypes.array,
  // contentHeight: PropTypes.number,
   isMobile: PropTypes.bool,
   lookViewType: PropTypes.number,
  // onScrollHandler: PropTypes.func,
  // loadingCount: PropTypes.number,
}

const mapStateToProps = (store) => {
  const {windowHeight, isMobile} = store.serverState;
  const {lookViewType} = store.lookState;
  return {
    windowHeight,
    isMobile,
    lookViewType,
  };
};

const mapDispatchToProps = {
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftOptionsLoading);
